import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  inactivePeriodChannel = new Subject();
  finishPeriodChannel = new Subject();
  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.inactivePeriodChannel.next({ status: apiResponse.INITIAL });
    this.finishPeriodChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  inactivePeriod = async (query) => {
    try {
      this.inactivePeriodChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .inactivePeriod(query)
        .then((result) => {
          this.inactivePeriodChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.inactivePeriodChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  finishPeriod = async (query) => {
    try {
      this.finishPeriodChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .finishPeriod(query)
        .then((result) => {
          this.finishPeriodChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.finishPeriodChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
}

export default DataTableBloc;
